import { BASE_FIELDS_URL } from './urls';

export const LAUNCH_DARKLY_CLIENT_ID = '6011a377e9aeb709db09d46e';

export const IMPORTED_SHAPEFILES_FEATURE_FLAG =
  'cfvweb.dmb.imported-shapefiles';
export const OTHER_IMAGERY_FEATURE_FLAG = 'cfvweb.dmb.other-imagery';
export const DMB_REDIRECT_URL = BASE_FIELDS_URL;
export const CROP_WATER_FEATURE_FLAG = 'cfvweb.dmb.crop-water-use';
export const SCOUTING_ACTIVITIES = 'cfvweb.dmb.scouting-activities';
export const FHA_EXPANDED_LEGEND_FEATURE_FLAG =
  'cfvweb.dmb.fha-expanded-legend';
export const DMB_TARGET_POPULATION_FEATURE_FLAG =
  'cfvweb.dmb.target-population';
export const PRECISION_PLANTING_MAPS_FEATURE_FLAG =
  'cfvweb.dmb.precision-planting-maps';
export const SCOUTING_REGIONS = 'cfvweb.dmb.scouting-regions';

// Launch Darkly
export const OL_HARVEST = 'web.harvest-yield-endpoint-migration';
export const DELARO_TRIAL_BLOCK = 'dmb.delaro-2022-trial-regions-visualization';
export const MICROSOFT_WEATHER = 'web.microsoft-weather';
export const MICROSOFT_WEATHER_GDD = 'web.microsoft-weather-gdd';
export const MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE = 'web.microsoft-weather-gdd-global-release';
export const MULTI_OPERATION_SELECTION = 'web.multi-operation-selection.dmb';
export const PLANET_LABS_POC = 'web.planet-labs-poc';
export const WEB_DMB_ENHANCED_SCOUTING = 'web-dmb-enhanced-scouting';
export const COMMERCIAL_POLICY_HISTORICAL_WEATHER = 'web.historical-weather-commercial-policy';
export const COMMERCIAL_POLICY_SCOUTING_ADD_PHOTO = 'web.scouting-add-photo-commercial-policy';
export const COMMERCIAL_POLICY_FIELD_REGION_REPORT = 'dmb.frr-commercial-policy-phase-1';
export const DMB_SPRAY_ASSIST = 'dmb.spray-assist-feature';
export const DMB_CROP_SEASON_FILTER = 'dmb.crop-season-filter-for-application-data';
export const DMB_FHA_TIMELAPSE = 'dmb-time-lapsed-fhi';
export const DMB_AG_VIZ_LEGEND_EDITION = 'dmb-ag-viz-legend-edition';

export const FEATURE_LIST = [
  IMPORTED_SHAPEFILES_FEATURE_FLAG,
  OTHER_IMAGERY_FEATURE_FLAG,
  CROP_WATER_FEATURE_FLAG,
  SCOUTING_ACTIVITIES,
  FHA_EXPANDED_LEGEND_FEATURE_FLAG,
  DMB_TARGET_POPULATION_FEATURE_FLAG,
  PRECISION_PLANTING_MAPS_FEATURE_FLAG,
  SCOUTING_REGIONS,
  DMB_SPRAY_ASSIST,
];
